import { ref, reactive } from 'vue'
import { ApiService } from '@/services/api'

export function useContact() {
  // Form reaktif verileri
  const form = reactive({
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  })

  // Form durumu
  const isSubmitting = ref(false)
  const showSuccessMessage = ref(false)

  // Telefon doğrulama fonksiyonu
  const validatePhone = (event) => {
    // Sadece rakam girişine izin ver
    const value = event.target.value.replace(/\D/g, '')
    
    // 10 haneli Türk telefon numarası formatı kontrol
    if (value.length <= 10) {
      form.phone = value
    }
  }

  // Form gönderme fonksiyonu
  const submitForm = async () => {
    if (isSubmitting.value) return

    try {
      isSubmitting.value = true

      const messageData = {
        name: `${form.first_name} ${form.last_name}`.trim(),
        email: form.email,
        phone: form.phone ? '+90' + form.phone : '',
        subject: form.subject,
        message: form.message
      }

      const result = await ApiService.sendContactMessage(messageData)

      if (result.success) {
        showSuccessMessage.value = true
        resetForm()
        
        // 3 saniye sonra mesajı gizle
        setTimeout(() => {
          showSuccessMessage.value = false
        }, 3000)
      } else {
        alert('Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin.')
        console.error('Contact form error:', result.message)
      }
    } catch (error) {
      console.error('Form submission error:', error)
      alert('Mesaj gönderilirken bir hata oluştu. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.')
    } finally {
      isSubmitting.value = false
    }
  }

  // Form temizleme fonksiyonu
  const resetForm = () => {
    form.first_name = ''
    form.last_name = ''
    form.email = ''
    form.phone = ''
    form.subject = ''
    form.message = ''
  }

  return {
    form,
    isSubmitting,
    showSuccessMessage,
    submitForm,
    validatePhone,
    resetForm
  }
}